// extracted by mini-css-extract-plugin
export const donateButton = "donate-button-module--donateButton--3Ok8j";